import { Component, EventEmitter, Input, Output } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { SubjectTypeService } from 'app/shared/services/subject-type.service';
import { SubjectType } from 'app/shared/models/subject-type';
import { AuthService } from 'app/shared/services/auth.service';

@Component({
  selector: 'subject-list-widget',
  templateUrl: './subject-list-widget.component.html',
  styleUrls: ['./subject-list-widget.component.scss'],
  animations: fuseAnimations,
})
export class SubjectListWidgetComponent {

  _data = [];
  selected: any;
  columns = [];
  _showSubjectTypeFilter = false;
  subjectTypeNames: string[] = [];

  loadingIndicator = false;
  reorderable = false;
  userReadOnly = false;
  admin = false;

  @Input() set data(val: any[]){
    this._data = val ? [...val]: [];
  }

  @Input() title: string;
  @Input() allowEdit = true;
  @Input() allowDelete = false;
  @Input() allowEditRelationship = false;
  @Input() allowSelect = true;
  @Input() titleBackgroundColor: string;
  @Input() readOnly = false;
  @Input() filterSubjectType = 'Case';
  @Input() set showSubjectTypeFilter(val: boolean){
    this._showSubjectTypeFilter = val;
    if (this._showSubjectTypeFilter){
      this.subjectTypeNames = [];
      this.subjectTypeService.getAllData().subscribe((subjectTypes: SubjectType[]) => {
        subjectTypes.filter((i) => !i.hideRecord).forEach((item) => {
          this.subjectTypeNames.push(item.name);
          // tslint:disable-next-line:only-arrow-functions
          this.subjectTypeNames.sort(function(a, b){return a.localeCompare(b); });
        });
      });
    }
  }
  @Input() noContentMessage = '';
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onFilterBySubjectType: EventEmitter<string> = new EventEmitter();
  @Output() onChangeRelationship: EventEmitter<any> = new EventEmitter();

  constructor(private subjectTypeService: SubjectTypeService, private authService: AuthService) {
    this.userReadOnly = this.authService.isUserReadOnly();
    this.admin = this.authService.hasPriv('admin');
  }

  select(row) {
    this.selected = row;
    this.onSelect.emit(row);
  }

  edit(row){
    this.onEdit.emit(row);
  }

  delete(row){
      this.onDelete.emit(row);
  }

  filterBySubjectType(subjectTypeName: string){
    this.filterSubjectType = subjectTypeName;
    this.onFilterBySubjectType.emit(subjectTypeName);
  }

  changeRelationship(link){
    this.onChangeRelationship.emit(link);
  }

}
